import BaseService from "@/services/BaseService";
import * as URI from "../workflow/constant";

const actions = {
  async workflowTriggerCheck({ commit }, payload) {
    let url = URI.SCHEME_WORKFLOW_TRIGGER.replace("{planNo}", payload.planNo);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async workflowCommTriggerCheck({ commit }, payload) {
    let url = URI.COMM_WORKFLOW_TRIGGER.replace(
      "{scheduleNo}",
      payload.scheduleNo
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async generateUserRequestId({ commit }, payload) {
    let url = URI.CREATE_USER_REQUEST_ID;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async generateWorkflowId({ commit }, payload) {
    let url = URI.GET_WORKFLOW_ID.replace("{requestId}", payload.requestId);
    const response = await BaseService.getDMSAxiosClient().get(url);
    return response.data;
  },
  async generateWorkflowIdIMS({ commit }, payload) {
    const workflowId = await BaseService.getSchemePlanningClient().put(
      URI.GET_WORKFLOW_ID_IMS_URL,
      payload
    );
    return workflowId.data;
  },
  async fetchSchemeApproval({ commit }, payload) {
    let url = URI.FETCH_WORKFLOW_DEF.replace("{defId}", payload.defId).replace(
      "{reqId}",
      payload.reqId
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setApprovalData", response.data);
    return response.data;
  },
  async fetchKnoxUserList({ commit }, payload) {
    let url = URI.GET_KNOX_USERS;
    const response = await BaseService.getDMSAxiosClient().post(url, {
      userId: payload,
    });
    return response.data;
  },

  async uploadApprovalAttachments({ commit }, payload) {
    let url = URI.UPLOAD_APPROVAL_ATTACHMENTS;
    const response = await BaseService.getDMSAxiosClient().post(url, payload);
    return response.data;
  },

  async removeApprovalAttachments({ commit }, payload) {
    let url = URI.DELETE_APPROVAL_ATTACHMENTS.replace("{docId}", payload.docId);
    const response = await BaseService.getDMSAxiosClient().delete(url);
    return response.data;
  },
  async saveSchemeApprovalRequest({ commit }, payload) {
    let url = URI.SUBMIT_APPROVAL.replace("{defId}", payload.defId)
      .replace("{planNo}", payload.planNo)
      .replace("{isRrfTot}", payload.isRrfTot);
    const payloadData = payload.data;
    payloadData.comment = "Workflow initiated";
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payloadData
    );
    return response.data;
  },
  async scheduleApprovalRequest({ commit }, payload) {
    let url = URI.SCHEDULE_APPROVAL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async getApprovalStatus({ commit }, payload) {
    let url = URI.APPROVAL_STATUS.replace("{reqId}", payload.requestId);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async cancelApprovalSubmission({ commit }, payload) {
    let url = URI.CANCEL_APPROVAL_SUBMISSION.replace(
      "{reqId}",
      payload.requestId
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async downloadApprovalAttachments({ commit }, payload) {
    let url = URI.DOWNLOAD_APPROVAL_ATTACHMENTS.replace(
      "{docId}",
      payload.docId
    ).replace("{docName}", payload.docName);
    const response = await BaseService.getDMSAxiosClient().get(url);
    return response.data;
  },
  async updateApprovalStatus({ commit }, payload) {
    let url = URI.UPDATE_APPROVAL_STATUS.replace(
      "{workflowStatus}",
      payload.workflowStatus
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.data
    );
    return response.data;
  },
  updateWorkflowData({ commit }, data) {
    commit("setApprovalData", data);
  },
  async saveSubmitScheduleAction({ commit }, data) {
    let url = URI.SAVE_SUBMIT_SCHEDULE.replace("{scheduleNumber}", data);
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response.data;
  },
  async saveSubmitAccrual({ commit }, data) {
    let url = URI.SAVE_SUBMIT_ACCRUAL.replace("{accuralNumber}", data);
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response.data;
  },
  async generateZipAction({ commit }, data) {
    let url = URI.ENTRY_IN_JOBQUE_LETTER_GENERATION.replace("{planNo}", data);
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response.data;
  },
  async downloadZipAction({ commit }, data) {
    let url = URI.GET_RRFTOT_ZIP.replace("{planNo}", data);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadZipActionInCommunication({ commit }, payload) {
    let url = URI.GET_RRFTOT_ZIP_IN_COMMUNICATION.replace(
      "{planNo}",
      payload.plan
    ).replace("{revId}", payload.revVerId);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async fetchEmailAttachmentFilesAction({ commit }, payload) {
    let url = URI.FETCH_EMAIL_ATTACHMENT_COMM.replace(
      "{scheduleId}",
      payload.scheduleId
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async workflowSubmitCommunicationPtisAction({ commit }, payload) {
    let url = URI.WORKFLOW_SUBMIT_COMMUNICATION_PTIS.replace("{definitionId}", payload.definitionId)
      .replace("{scheduleNo}", payload.scheduleNo)
    const payloadData = payload.workflowDTO;
    // payloadData.comment = "Workflow initiated";
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payloadData
    );
    return response.data;
  },
  async cancelApprovalCommAction({ commit }, payload) {
    let url = URI.CANCEL_APPROVAL_COMM.replace(
      "{workflowRqstId}",
      payload.workflowRqstId
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async cancelRequestAction({ commit }, payload) {
    let url = URI.CANCEL_REQUEST;
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response.data;
  },
};

export default actions;
